let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("03ELB")).then(() => parcelRequire('lWy4q'));